export enum DrawResultsPickerType {
    SortAscending = "ŘADIT VZESTUPNĚ",
    SortByDraw = "ŘADIT DLE SLOSOVÁNÍ",
}
